import React from 'react';
import { Link } from "react-router-dom";
import {
  Layout, Menu, Icon, Card, Row, Col, InputNumber,
  Radio, Divider, Statistic, Progress, Alert
} from 'antd';
import '../../assets/css/App.css';
import Header1 from '../public';
import BicombImg from "../../assets/images/Diameter.jpg";

const { Content, Sider } = Layout;
const SubMenu = Menu.SubMenu;

class Diameter extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      maxDiameter: 46,
      age: "<65",
      sex: "Female",
      smoking: "No",
      line: "≥2L",
      regimen: "Mono",
      region: "EastAsia",
    };
  }

  getDiameterPoints = (d) => {
    const anchors = [
      { diameter: 0, points: 0 },
      { diameter: 20, points: 5 },
      { diameter: 40, points: 9 },
      { diameter: 60, points: 12 },
      { diameter: 80, points: 21 },
      { diameter: 100, points: 32 },
      { diameter: 120, points: 46 },
      { diameter: 140, points: 59 },
      { diameter: 160, points: 72 },
      { diameter: 180, points: 85 },
    ];

    const value = Math.max(0, Math.min(180, Number(d) || 0));

    if (value <= anchors[0].diameter) return anchors[0].points;
    if (value >= anchors[anchors.length - 1].diameter) {
      return anchors[anchors.length - 1].points;
    }

    for (let i = 0; i < anchors.length - 1; i++) {
      const a = anchors[i];
      const b = anchors[i + 1];

      if (value >= a.diameter && value <= b.diameter) {
        const t = (value - a.diameter) / (b.diameter - a.diameter);
        return a.points + t * (b.points - a.points);
      }
    }

    return 0;
  };

  getCategoryPoints = () => {
    const { age, sex, smoking, line, regimen, region } = this.state;

    return {
      age: age === "≥65" ? 22 : 0,
      sex: sex === "Male" ? 7 : 0,
      smoking: smoking === "Yes" ? 11 : 0,
      line: line === "1L" ? 22 : 0,
      regimen:
        regimen === "Chemo" ? 2 :
          regimen === "Other" ? 4 : 0,
      region:
        region === "EastAsia" ? 0 :
          region === "Europe" ? 29 : 100,
    };
  };

  getTotalPoints = () => {
    const categoryPoints = this.getCategoryPoints();
    return (
      this.getDiameterPoints(this.state.maxDiameter) +
      Object.values(categoryPoints).reduce((a, b) => a + b, 0)
    );
  };

  pointsToLinearPredictor = (points) => {
    return -0.9 + (points / 240) * 2.9;
  };

  survivalFromLP = (lp, baseline) => {
    const s = Math.pow(baseline, Math.exp(lp));
    return Math.max(0.01, Math.min(0.99, s));
  };

  getSurvival = () => {
    const lp = this.pointsToLinearPredictor(this.getTotalPoints());

    return {
      m12: this.survivalFromLP(lp, 0.78),
      m24: this.survivalFromLP(lp, 0.52),
      m36: this.survivalFromLP(lp, 0.34),
      m60: this.survivalFromLP(lp, 0.22),
    };
  };

  updateValue = (key, value) => {
    this.setState({ [key]: value });
  };

  renderRadio = (title, key, options) => (
    <Card
      bordered={false}
      style={{
        marginBottom: 14,
        borderRadius: 10,
        border: '1px solid #e8edf3',
        background: '#ffffff'
      }}
      bodyStyle={{ padding: '14px 18px' }}
    >
      <div style={{ fontSize: 15, fontWeight: 600, marginBottom: 10 }}>
        {title}
      </div>
      <Radio.Group
        value={this.state[key]}
        onChange={(e) => this.updateValue(key, e.target.value)}
      >
        {options.map(opt => (
          <Radio.Button key={opt} value={opt}>
            {opt}
          </Radio.Button>
        ))}
      </Radio.Group>
    </Card>
  );

  getSurvivalColor = (value) => {
    const percent = value * 100;

    if (percent < 35) return 'rgba(220, 53, 69, 0.22)';      // red
    if (percent < 65) return 'rgba(250, 173, 20, 0.24)';     // yellow
    return 'rgba(82, 196, 26, 0.24)';                        // green
  };

  renderSurvivalCard = (label, value) => {
    const percent = Number((value * 100).toFixed(1));
    const barColor = this.getSurvivalColor(value);

    return (
      <div
        key={label}
        style={{
          position: 'relative',
          overflow: 'hidden',
          borderRadius: 12,
          border: '1px solid #e5eaf0',
          background: '#ffffff',
          marginBottom: 12,
          minHeight: 58,
        }}
      >
        <div
          style={{
            position: 'absolute',
            left: 0,
            top: 0,
            bottom: 0,
            width: `${percent}%`,
            background: barColor,
            transition: 'width 0.3s ease',
            zIndex: 1,
          }}
        />

        <Row
          type="flex"
          align="middle"
          style={{
            position: 'relative',
            zIndex: 2,
            minHeight: 58,
            padding: '0 16px',
          }}
        >
          <Col span={14}>
            <div style={{ fontSize: 15, color: '#5b6675', fontWeight: 600 }}>
              {label}
            </div>
          </Col>

          <Col span={10} style={{ textAlign: 'right' }}>
            <span style={{ fontSize: 26, fontWeight: 700, color: '#1f2933' }}>
              {percent.toFixed(1)}
            </span>
            <span style={{ fontSize: 16, marginLeft: 4, color: '#1f2933' }}>
              %
            </span>
          </Col>
        </Row>
      </div>
    );
  };

  render() {
    const totalPoints = this.getTotalPoints();
    const lp = this.pointsToLinearPredictor(totalPoints);
    const survival = this.getSurvival();
    const diameterPoints = this.getDiameterPoints(this.state.maxDiameter);
    const categoryPoints = this.getCategoryPoints();

    return (
      <div>
        <Header1 />

        <Content style={{ padding: '0 50px' }}>
          <Layout style={{ background: '#fff' }}>
            <Sider width={200} style={{ background: '#fff' }}>
              <Menu
                mode="inline"
                selectedKeys={[this.props.location.pathname]}
                defaultOpenKeys={['sub1']}
                style={{ height: '100%', borderRight: 0, background: '#fafbfc' }}
              >
                <SubMenu
                  key="sub1"
                  title={
                    <span style={{ fontWeight: 600, fontSize: 16 }}>
                      <Icon type="medicine-box" style={{ marginRight: 8 }} />
                      Diameter
                    </span>
                  }
                >
                  <Menu.Item key="/Diameter" style={{ paddingLeft: 32 }}>
                    <Link to="/Diameter">
                      <span style={{ fontSize: 15 }}>OS Prediction Model</span>
                    </Link>
                  </Menu.Item>
                </SubMenu>
              </Menu>
            </Sider>

            <Content style={{ padding: '0 50px' }}>
              <div
                style={{
                  background: `url(${BicombImg}) no-repeat center center`,
                  height: 280,
                  width: "100%",
                  backgroundSize: "cover",
                  borderRadius: 14,
                  marginBottom: 34,
                }}
              >
                <div style={{ paddingTop: 76, paddingLeft: 52 }}>
                  <div style={{ fontSize: 42, fontWeight: 700, color: '#0f3b63' }}>
                    Baseline tumor diameter-based nomogram for OS
                  </div>
                  <div style={{ fontSize: 42, fontWeight: 700, color: '#0f3b63' }}>
                    prediction in patients with NSCLC immunotherapy
                  </div>
                  <div style={{ fontSize: 22, color: '#0f3b63', marginTop: 10 }}>

                  </div>
                </div>
              </div>

              <Card
                bordered={false}
                style={{
                  borderRadius: 16,
                  border: '1px solid #dde5ee',
                  boxShadow: '0 6px 24px rgba(15, 59, 99, 0.08)',
                  marginBottom: 28
                }}
                bodyStyle={{ padding: 28 }}
              >
                <Row gutter={28}>
                  <Col xs={24} lg={15}>
                    <div style={{ fontSize: 24, fontWeight: 700, marginBottom: 6 }}>
                      Patient Characteristics
                    </div>
                    <div style={{ fontSize: 15, color: '#667085', marginBottom: 22 }}>
                      Enter baseline variables to estimate 12-month, 24-month, 36-month, and 60-month overall survival.
                    </div>

                    <Card
                      bordered={false}
                      style={{
                        marginBottom: 14,
                        borderRadius: 10,
                        border: '1px solid #e8edf3',
                        background: '#ffffff'
                      }}
                      bodyStyle={{ padding: '16px 18px' }}
                    >
                      <Row type="flex" align="middle">
                        <Col xs={24} md={12}>
                          <div style={{ fontSize: 15, fontWeight: 600 }}>
                            Maximum tumor diameter
                          </div>
                          <div style={{ fontSize: 13, color: '#7a8699', marginTop: 4 }}>
                            Range used in the nomogram: 0 to 180 mm
                          </div>
                        </Col>
                        <Col xs={24} md={12} style={{ textAlign: 'right' }}>
                          <InputNumber
                            min={0}
                            max={180}
                            value={this.state.maxDiameter}
                            onChange={(value) => this.updateValue('maxDiameter', value)}
                            formatter={value => `${value} mm`}
                            parser={value => value.replace(' mm', '')}
                            style={{ width: 160 }}
                          />
                        </Col>
                      </Row>
                    </Card>

                    {this.renderRadio("Age", "age", ["<65", "≥65"])}
                    {this.renderRadio("Sex", "sex", ["Female", "Male"])}
                    {this.renderRadio("Smoking status", "smoking", ["No", "Yes"])}
                    {this.renderRadio("Line of therapy", "line", ["≥2L", "1L"])}
                    {this.renderRadio("Treatment regimen", "regimen", ["Mono", "Chemo", "Other"])}
                    {this.renderRadio("Geographic region", "region", ["EastAsia", "Europe", "NorthAmerica"])}
                  </Col>

                  <Col xs={24} lg={9}>
                    <Card
                      bordered={false}
                      style={{
                        borderRadius: 14,
                        background: '#f7fafc',
                        border: '1px solid #dce7f2'
                      }}
                      bodyStyle={{ padding: 24 }}
                    >
                      <div style={{ fontSize: 22, fontWeight: 700, marginBottom: 18 }}>
                        Prediction Summary
                      </div>

                      <Row gutter={12}>
                        <Col span={12}>
                          <Statistic
                            title="Total points"
                            value={totalPoints.toFixed(1)}
                          />
                        </Col>
                        <Col span={12}>
                          <Statistic
                            title="Linear predictor"
                            value={lp.toFixed(2)}
                          />
                        </Col>
                      </Row>

                      <Divider />

                      <div>
                        {this.renderSurvivalCard("12-month OS", survival.m12)}
                        {this.renderSurvivalCard("24-month OS", survival.m24)}
                        {this.renderSurvivalCard("36-month OS", survival.m36)}
                        {this.renderSurvivalCard("60-month OS", survival.m60)}
                      </div>

                      <Divider />

                      <div style={{ fontSize: 16, fontWeight: 700, marginBottom: 12 }}>
                        Point contribution
                      </div>

                      {[
                        ["Maximum diameter", diameterPoints],
                        ["Age", categoryPoints.age],
                        ["Sex", categoryPoints.sex],
                        ["Smoking", categoryPoints.smoking],
                        ["Line", categoryPoints.line],
                        ["Regimen", categoryPoints.regimen],
                        ["Region", categoryPoints.region],
                      ].map(([label, value]) => (
                        <Row key={label} style={{ marginBottom: 8 }}>
                          <Col span={15} style={{ color: '#5b6675' }}>{label}</Col>
                          <Col span={9} style={{ textAlign: 'right', fontWeight: 700 }}>
                            {value.toFixed(1)}
                          </Col>
                        </Row>
                      ))}

                      <Alert
                        style={{ marginTop: 20 }}
                        type="info"
                        showIcon
                        message="Clinical interpretation"
                        description="This calculator provides individualized survival estimates based on the nomogram model and should be interpreted together with clinical judgment."
                      />
                    </Card>
                  </Col>
                </Row>
              </Card>

              <div style={{ fontSize: 18, lineHeight: 1.8, marginBottom: 40 }}>
                Please cite the following study if using information from this website:
                <br />
                <span style={{ fontStyle: 'italic' }}>
                  Baseline tumor diameter shapes survival outcomes in non–small cell lung cancer immunotherapy.
                </span>
              </div>
            </Content>
          </Layout>
        </Content>
      </div>
    );
  }
}

export default Diameter;